import { render, staticRenderFns } from "./HotelPrice.vue?vue&type=template&id=02baf4f4&scoped=true"
import script from "./HotelPrice.vue?vue&type=script&lang=js"
export * from "./HotelPrice.vue?vue&type=script&lang=js"
import style0 from "./HotelPrice.vue?vue&type=style&index=0&id=02baf4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02baf4f4",
  null
  
)

export default component.exports